import(/* webpackMode: "eager", webpackExports: ["PageSkeleton"] */ "/app/apps/web/src/app/components/page-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouterLoadingIndicator"] */ "/app/apps/web/src/components/router-loading-indicator.tsx");
